import { useQuery } from "@tanstack/react-query";
import { getPatientAppointments } from "../services/apiServices";
import { useEffect } from "react";

export const useAppointments = (patientId, onSuccessCallback) => {
  const query = useQuery({
    queryKey: ["appointments", patientId],
    queryFn: () => getPatientAppointments(patientId),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    enabled: !!patientId,
  });

  useEffect(() => {
    if (query.isSuccess && onSuccessCallback && query.data.length > 0) {
      onSuccessCallback(query.data[0].appointment_id);
    }
  }, [query.isSuccess, query.data, onSuccessCallback]);

  return query;
};